import usePropertyService from 'api/services/propertyService'
import Loading from 'components/common/loading/Loading'
import Modal from 'components/common/modal/Modal'
import TagsList from 'components/listing/TagsList'
import UnitCard from 'components/listing/UnitCard'
import { useEffect, useState } from 'react'
import { useQuery } from 'react-query'
import { useLocation, useNavigate, useParams } from 'react-router-dom'

const MyListing = () => {
  const navigate = useNavigate()
  const location = useLocation()
  const { id } = useParams()
  const { loadListedProperty, loadTags } = usePropertyService()
  const [listing, setListing] = useState<any>(null)

  const { data: propertyData, isLoading } = useQuery(
    ['loadProperty', id],
    () => loadListedProperty(id!),
    { enabled: !!id }
  )

  const { data: allTags } = useQuery('loadTags', loadTags, {
    enabled: !!id,
  })
  const returnTo =
    (location.state as { returnTo?: string } | null)?.returnTo || '/account'
  const handleClose = () => navigate(returnTo)

  const handleAddTag = (category: string, tagId: string) => {
    return { category, tagId }
  }

  useEffect(() => {
    if (propertyData) {
      setListing(propertyData)
    }
  }, [propertyData])

  if (!listing || isLoading) return <Loading />

  return (
    <Modal
      isOpen
      onClose={handleClose}
      title={listing.title}
      icon="regular-house"
    >
      <div className="relative w-full h-full">
        <div className="p-4">
          <UnitCard unit={listing} />
          {listing.tags.map((tag: any, index: number) => (
            <TagsList
              key={`${tag.id}-${index}`}
              label={tag.label}
              icon={tag.icon}
              currentTags={tag.tags}
              allTags={allTags[tag.category].tags}
              handleAddTag={handleAddTag}
            />
          ))}
        </div>
      </div>
    </Modal>
  )
}

export default MyListing
